// extracted by mini-css-extract-plugin
export var statItem = "_kb-1";
export var statsRow = "_kb-0";